import { darkColors, lightColors } from "common/theme/colors";

export const light = {
	background: lightColors.card,
};

export const dark = {
	background: darkColors.card,
};
